import useDocumentTitle from "@/components/ui/common/document-title";
import OtherReportTable from "./table";

export default function OtherReport() {
  useDocumentTitle("Other Report");

  return (
    <div className="w-full p-5 space-y-6">
      <div className="space-y-6">
        <OtherReportTable />
      </div>
    </div>
  );
}
